// authApi.js
// src/features/auth/services/authApi.js
import httpClient from '../../../shared/services/httpClient';

const authApi = {
  login: (credentials) => {
    return httpClient.post('/auth/login', credentials);
  },
  
  register: (userData) => {
    return httpClient.post('/auth/register', userData);
  },
  
  forgotPassword: (email) => {
    return httpClient.post('/auth/forgot-password', { email });
  },
  
  resetPassword: (data) => {
    return httpClient.post('/auth/reset-password', data);
  },
  
  logout: () => {
    return httpClient.post('/auth/logout');
  },
  
  getCurrentUser: () => {
    return httpClient.get('/auth/me');
  },
  
  refreshToken: () => {
    return httpClient.post('/auth/refresh');
  },
};

export default authApi;